import styled, { css } from "styled-components";
import { theme } from "../../core/tokens";
import { getPropertyByMedia, getThemeMedia, getThemeSpace, getThemeTokenParser } from "../helpers";
const getResponsiveColumnValue = (columns, size) => {
    return typeof columns === "object" ? columns[size] : columns;
};
const getResponsiveValue = (value, size) => {
    return typeof value === "object" ? value[size] : value;
};
const getColumnSize = (columns, size, startAt, width) => {
    const itemSize = width ? getResponsiveValue(width, size) : undefined;
    const initialColumn = startAt ? getResponsiveValue(startAt, size) : undefined;
    return css `
		grid-column-start: ${initialColumn || "auto"};
		grid-column-end: ${itemSize && initialColumn ? itemSize + initialColumn : `span ${getResponsiveColumnValue(columns, size)}`};
	`;
};
const getUnitWidthBySize = (width, size, viewPort = "100vw") => {
    const columnQuantity = getResponsiveValue(width, size);
    const safetyPaddings = `${theme.safetyPadding[size] * 2}px`;
    const columnsNumber = theme.columns[size];
    const gapsToDiscount = `${(columnsNumber - 1) * theme.gutter[size]}px`;
    const gapsToReplace = `${(columnQuantity - 1) * theme.gutter[size]}px`;
    // prettier-ignore
    return css `
		width: calc(
			(((${viewPort} - ${safetyPaddings} - ${gapsToDiscount}) / ${columnsNumber}) * ${columnQuantity}) + ${gapsToReplace}
		);
	`;
};
const getChildColumnSize = (columns, size) => css `
	& > * {
		${getColumnSize(columns, size)}
	}
`;
const getResponsiveStyles = ({ columns, itemColumns, size, customColumnsNumber, startAt, width, }) => {
    const columnsNumber = customColumnsNumber ? getResponsiveColumnValue(customColumnsNumber, size) : theme.columns[size];
    return css `
		grid-template-columns: repeat(${columnsNumber}, 1fr);

		${width && getUnitWidthBySize(width, size)}
		${itemColumns && getChildColumnSize(itemColumns, size)}
		${columns && getColumnSize(columns, size, startAt, width)}
	`;
};
export const StyledColumns = styled.div `
	display: ${({ columns }) => (columns ? "initial" : "grid")};

	gap: ${getThemeSpace(String(theme.gutter.small))};
	row-gap: ${({ rowGap }) => getPropertyByMedia("row-gap", getThemeTokenParser(rowGap, "space"), "16px")};
	width: 100%;
	${({ alignSelf }) => getPropertyByMedia("align-self", alignSelf, "initial")};

	${({ columns, itemColumns, customColumnsNumber, startAt, width }) => getResponsiveStyles({ size: "small", columns, itemColumns, customColumnsNumber, startAt, width })}

	${({ position }) => getPropertyByMedia("position", position)};
	${({ top }) => getPropertyByMedia("top", top)}
	${({ right }) => getPropertyByMedia("right", right)}
	${({ bottom }) => getPropertyByMedia("bottom", bottom)}
	${({ left }) => getPropertyByMedia("left", left)}
	${({ zIndex }) => getPropertyByMedia("z-index", zIndex)};

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			gap: ${getThemeSpace(String(theme.gutter.medium))};
			${({ columns, itemColumns, customColumnsNumber, startAt, width }) => getResponsiveStyles({ size: "medium", columns, itemColumns, customColumnsNumber, startAt, width })}
		}

		@media (min-width: ${getThemeMedia("large")}) {
			gap: ${getThemeSpace(String(theme.gutter.large))};
			${({ columns, itemColumns, customColumnsNumber, startAt, width }) => getResponsiveStyles({ size: "large", columns, itemColumns, customColumnsNumber, startAt, width })}
		}

		@media (min-width: 1366px) {
			${({ width }) => width && getUnitWidthBySize(width, "large", "1366px")}
		}
	}
`;
const getSafetyPaddings = (breakpoint, hasVerticalPaddings = true) => {
    const { safetyPadding } = theme;
    const currentPadding = `${safetyPadding[breakpoint]}px`;
    return hasVerticalPaddings ? `32px ${currentPadding} 120px` : `0 ${currentPadding}`;
};
export const SafetyPadding = styled.div `
	width: 100vw;
	max-width: 1366px;
	margin: 0 auto;

	padding: ${({ verticalPaddings }) => getSafetyPaddings("small", verticalPaddings)};

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			padding: ${({ verticalPaddings }) => getSafetyPaddings("medium", verticalPaddings)};
		}

		@media (min-width: ${getThemeMedia("large")}) {
			padding: ${({ verticalPaddings }) => getSafetyPaddings("large", verticalPaddings)};
		}
	}
`;
//# sourceMappingURL=styles.js.map